import Image from '~/components/Image';

const THUMBNAIL_SIZE = 150;

type Props = {
  alt: string;
  isSquare: boolean;
  src: string;
};

export default function SearchResultThumbnail({ alt, isSquare, src }: Props) {
  return (
    <Image
      alt={alt}
      src={src}
      width={THUMBNAIL_SIZE}
      height={isSquare ? THUMBNAIL_SIZE : undefined}
      loading="lazy"
      className="w-full"
    />
  );
}
